import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { TitleOutlined } from '@mui/icons-material';
import { useAppSelector, useAppDispatch } from '../../../../../../app/hooks';
import { updateGeneralTicketTemplate } from '../../../../state';

/**
 * RecurringTaskGeneralTicketTitleEditor - Editor for the ticket title that will be used when creating tickets
 * This is separate from the recurring task's own title
 */
export const RecurringTaskGeneralTicketTitleEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const recurringTask = useAppSelector(state => state.recurringTask.currentRecurringTask);

  const handleChange = (value: string) => {
    dispatch(updateGeneralTicketTemplate({ ticketTitle: value }));
  };

  return (
    <TextField
      label="Ticket Title"
      value={recurringTask?.generalTicketTemplate?.ticketTitle || ''}
      onChange={(e) => handleChange(e.target.value)}
      size="small"
      fullWidth
      required
      placeholder="Enter the title for tickets created from this template"
      helperText="This title will be used for all tickets created from this recurring task"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <TitleOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default RecurringTaskGeneralTicketTitleEditor;
